<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="5/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            <p>Der Kokon PAUL befand sich im Zeitraum von 2004 bis 2009 auf dem Gelände des Institutes für Leichtbau Entwerfen und Konstruieren ILEK an der Universität Stuttgart. Markus Holzbach hat Paul dort im Rahmen seiner Dissertation über adaptive und konditionierende textile Gebäudehüllen realisiert. PAUL zeigt Analogien gebauter Architektur zu lebenden Organismen auf. Insgesamt ist der Wandaufbau mit seinen verschiedenen Lagen und Zellen dem Aufbau einer lebenden Haut ähnlich und dient als vermittelnde Membran zwischen Innen und Außen. Die Gesamtdicke der Multilayerkontruktion beträgt nur 14 mm und führt zu transluzenten Eigenschaften des konditionierenden Wandaufbaus – daraus leiten sich funktionale und gestalterische Impulse ab. Es kommen neben hochisolierenden Keramiken auch speicherfähige Phasenwechselmaterialien zum Einsatz. Die Speicher- und Isolationsschichten bauen sich aus über 60.000 Funktionszellen auf. Speicher- und Dämmwerte sind denen einer Massivwand von etwa 150 mm Stärke vergleichbar. PAUL verfügt als Leichtbau über die Fähigkeit zur selbsttätigen Anpassung an veränderliche Umweltbedingungen. </p>
        </div>
        <tailwind-image
            v-if="linkExists(1)"
            :link="links[1]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(3)"
                :link="links[3]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(4)"
            :link="links[4]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(6)"
                :link="links[6]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf und Realisierung</p>
            <p>Markus Holzbach am ILEK, Universität Stuttgart</p>
        </span>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/full/Plan Paul Formade Kopie.jpg' ),
                require( '@/assets/img/pc/paul6x6_65-2.jpg' ),
                require( '@/assets/img/pc/paul_24.jpg' ),
                require( '@/assets/img/pc/IMG_2907.jpg' ),
                require( '@/assets/img/pc/paul_1.jpg' ),
                require( '@/assets/img/pc/paul_03.jpg' ),
                require( '@/assets/img/pc/paul_04.jpg' ),
                require( '@/assets/img/pc/paul_54.jpg' ),
                require( '@/assets/img/pc/paul_92.jpg' ),
                require( '@/assets/img/pc/paul_74.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>